import {
  BarChart3,
  Brain,
  CalendarDays,
  IdCard,
  LayoutGrid,
  MessageSquare,
  Store,
  Tag,
  UserCog,
  Users,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  key: string;
  label: string;
  href: string;
  icon: LucideIcon;
  /** Item só de organizador — porta `org: true` do legado. Gate de UX
   *  (esconde o link); a barreira real é o 403 do backend. Ver useIsOrg(). */
  org?: boolean;
  /** Badge de contagem, alimentado por `useNavBadges` (TanStack Query). */
  badgeKey?: "nav-kb" | "nav-fila" | "nav-part";
}

export type NavEntry = NavItem | { group: string };

/**
 * Fonte única de navegação do painel — nova Arquitetura da Informação
 * (decisão de produto, substitui o agrupamento "Inteligência"/"Operação" do
 * scaffold original). Cada `NavItem` mantém `label` separado de `icon` de
 * propósito: um futuro modo colapsado/só-ícones (não implementado agora,
 * ver `layouts/Sidebar.tsx`) poderia mostrar só `icon` + `Tooltip(label)`
 * sem precisar mudar esta lista.
 *
 * "Visão geral" é o único item de primeiro nível fora de qualquer grupo —
 * é a entrada principal do painel administrativo. Os `{ group }` que
 * seguem são renderizados como rótulo discreto (ver `Sidebar.tsx`); o
 * texto abaixo já está na forma como deve aparecer na tela (o CSS aplica
 * uppercase, não é preciso digitar em caixa alta aqui).
 *
 * "Simular no WhatsApp" (rota `/poc-whatsapp`) e "WhatsApp & templates"
 * (rota `/whatsapp`) deliberadamente NÃO têm entrada aqui — ver
 * `layouts/Topbar.tsx` (ação contextual para a PoC) e `AppRouter.tsx`
 * (kill-switch de `/whatsapp`) para onde cada rota continua acessível.
 */
export const NAV: NavEntry[] = [
  { key: "visao-geral", label: "Visão geral", href: "/visao-geral", icon: LayoutGrid },

  { group: "Evento" },
  { key: "evento", label: "Evento & marca", href: "/evento", icon: Tag, org: true },
  { key: "agenda", label: "Agenda", href: "/agenda", icon: CalendarDays },
  {
    key: "participantes",
    label: "Participantes",
    href: "/participantes",
    icon: Users,
    badgeKey: "nav-part",
  },
  { key: "expositores", label: "Expositores", href: "/expositores", icon: Store },

  { group: "Operação ao vivo" },
  {
    key: "atendimento",
    label: "Atendimento",
    href: "/atendimento",
    icon: MessageSquare,
    badgeKey: "nav-fila",
  },

  { group: "Inteligência" },
  {
    key: "cerebro-ia",
    label: "Cérebro da IA",
    href: "/cerebro-ia",
    icon: Brain,
    badgeKey: "nav-kb",
  },

  { group: "Resultados" },
  { key: "relatorios", label: "Relatórios", href: "/relatorios", icon: BarChart3 },

  { group: "Administração" },
  { key: "usuarios", label: "Usuários", href: "/usuarios", icon: UserCog, org: true },
  { key: "admin", label: "Auditoria", href: "/admin", icon: IdCard, org: true },
];
